"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const nameFunction_1 = require("./nameFunction");
const React = require("react");
class PureComponentWrap extends React.PureComponent {
    render() {
        const _a = this.props, { _inner } = _a, others = __rest(_a, ["_inner"]);
        return _inner(others);
    }
}
exports.PureFunctional = function (name) {
    return (render) => {
        const component = Object.assign(nameFunction_1.nameFunction(`PureFunctional_${name}`, function PureFunction(props) {
            return React.createElement(PureComponentWrap, Object.assign({ _inner: render }, props));
        }), {
            displayName: `PureFunctional(${name})`,
        });
        return component;
    };
};
//# sourceMappingURL=PureFunctional.js.map


// WEBPACK FOOTER //
// ./node_modules/react-redux-pure/es6/PureFunctional.js